import { Component, ElementRef, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExsepService } from '../../services/exsep/exsep.service';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import {FormatDate} from '../../utils/date.util';
import {
  ApplicationStatus,
  ApplicationStatusLabel,
} from '../../Enums/application-status.enum';

@Component({
    selector: 'app-services-request',
    templateUrl: './services-request.component.html',
    styleUrl: './services-request.component.scss',
    standalone: false
})
export class ServicesRequestComponent implements OnInit {
  searchValue: string = '';
  spinnerKey: string = 'spinner';

  filterData: any;
  filterDataInit: any = {};
  filterParamsUrl: any = {};
  filterPage: string = 'CLASSIFICATION_APPLICATIONS';
  formatDate = FormatDate;
  spinner: boolean = true;
  private destroyRef = inject(DestroyRef);

  config: any;
  page: number = 1;
  page_size: number = 20;
  totalRecords: any;

  servicesRequestsList: any[] = [];
  pageTitle: string = '';
  expertType: string = '';
  applicationStatus = ApplicationStatus;
  applicationStatusLabel = ApplicationStatusLabel;
  imgDefault: string = '/assets/images/svg/sort-default.svg';
  imgASC: string = '/assets/images/svg/sort-up.svg';
  imgDesc: string = '/assets/images/svg/sort-down.svg';
  @ViewChild('goUp', { static: true }) contentPage!: ElementRef;

  constructor(
    private titleService: Title,
    private exsepService: ExsepService,
    private router: Router,
    private route: ActivatedRoute,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
  ) {
    this.config = {
      id: 'servicesRequestsPagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit(): void {
    // Get configuration from route data
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (data['config']) {
        this.pageTitle = data['config'].pageTitle;
        this.filterPage = data['config'].filterPage;
      }
    });

    this.setupQueryParamsSubscription();
    this.getFiltersData();
    this.titleService.setTitle(this.pageTitle + ' | عاين');
    this.initializeFilters();
  }

  private setupQueryParamsSubscription(): void {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params?.['page'] && params?.['page_size']) {
        this.page = Number(params['page']);
        this.page_size = Number(params['page_size']);
        this.config.currentPage = Number(params['page']);
        this.config.itemsPerPage = Number(params['page_size']);
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }

      this.filterUtil.clearfilterParams(this.filterParamsUrl);
      this.filterUtil.clearfilterParams(this.filterDataInit);
      if (Object.keys(params).length > 0) {
        this.searchValue = params['search'] ? params['search'] : '';
        this.filterParamsUrl = { ...params };
        this.filterDataInit = { ...params };
      }
    });
  }

  private initializeFilters(): void {
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(
      this,
      this.getServicesRequestsList,
      this.spinnerKey,
    );
  }

  getFiltersData() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data: any) => {
        this.filterData = data;
      },
      (error: any) => {
        this.handleBackendError(error);
      },
    );
  }

  getServicesRequestsList() {
    let params: any = { ...this.filterParamsUrl };
    params['page'] = this.config.currentPage;
    params['page_size'] = this.config.itemsPerPage;

    // Mock data for demonstration - replace with actual API call
    this.exsepService.getServiceRequest(params).subscribe({
      next: (response) => {
        this.servicesRequestsList = response.data;
        this.config.totalItems = response.count;
        this.spinner = false;
      },
      error: (error) => {
        this.handleBackendError(error);
        this.spinner = false;
      },
    });

  }

  getStatusClass(status: string): string {
    const statusClasses: Record<string, string> = {
      [this.applicationStatus.ACCEPTED]: 'status-approved',
      [this.applicationStatus.REJECTED]: 'status-rejected',
      [this.applicationStatus.UNDER_REVIEW]: 'status-pending',
      [this.applicationStatus.REVISION_NEEDED]: 'status-pending',
      [this.applicationStatus.SUSPENDED]: 'status-rejected',
    };
    return statusClasses[status] || '';
  }

  openDetails(requestId: number) {
    // Navigate to details page
    this.router.navigate(['/pages/sopra/services-requests', requestId]);
  }

  filterFormValues(event: any) {
    this.filterParamsUrl = event.filterParamsUrl;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getServicesRequestsList();
  }

  quickSearch(event: any) {
    if(event === this.searchValue ) return; 
    this.searchValue = event;
    if(!this.searchValue) {
      delete this.filterParamsUrl['search'];
    } else {
      this.filterParamsUrl['search'] = this.searchValue;
    }
    this.spinner = true;
    this.config.currentPage = 1;
    this.getServicesRequestsList();
  }

  pageChanged(event: any) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page',
      event,
    );
    this.config.currentPage = event;
    this.getServicesRequestsList();
  }

  pageSizeChanged(event: any) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page_size',
      event,
    );
    this.getServicesRequestsList();
  }

  changeToSpecific(event: any) {
    this.pageChanged(event);
  }

  handleBackendError(error: any) {
    console.error('Error:', error);
  }

 
  goInspector(event: Event, internalId: string){
    event.stopPropagation();
    event.preventDefault();
    this.router.navigate(['/pages/inspectors/inspector-profile/', internalId]);
  }
 
}
